
import AppBar from '@material-ui/core/AppBar';
import Checkbox from '@material-ui/core/Checkbox';
import Drawer from '@material-ui/core/Drawer';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import React, { useEffect, useState } from 'react';
import TemplateForm from '../../core/modules/template/template';
import { createRequest, requestApi as requestApiNew } from '../../core/controls/helpers/rest';
import IconButton from '@material-ui/core/IconButton';
import BackIcon from '@material-ui/icons/ChevronLeft';


export default function TermsAndCond({ handleAgreement, handleClose, agreement, url, SITE_PERMIT_TYPE_ID, openTerms }) {

    const [editorState, seteditor] = useState();
    const [tAndC, settAndC] = useState();

    useEffect(() => {
        let arrayUrl = [
            { url: url.get.url + '/' + SITE_PERMIT_TYPE_ID, type: 'get' },
        ]
        Promise.all(arrayUrl.map(each => requestApiNew(createRequest(each)))).then(res => {
            const [tAndC] = res
            if (tAndC && tAndC.Id) {
                seteditor(parseInt(atob(tAndC.TermsAndConditionsStr))); settAndC(tAndC)
            }
        }).catch(ex => {

        })
    }, [])


    return <Drawer anchor="right" PaperProps={{ style: { width: window.innerWidth - 520 } }} classes={{ paper: window.innerWidth - 200 || '' }} open={openTerms}>
        <AppBar position="static" color='secondary'>
            <Toolbar variant="dense">
                <Typography variant="h6" color="inherit" >
                    Terms and Conditions
                </Typography>
                <div className='flex-grow-1'></div>
                <IconButton color="inherit" onClick={handleClose} title="Back" >
                    <BackIcon />
                </IconButton>         
            </Toolbar>
        </AppBar>
        {editorState && <TemplateForm templateId={editorState} isEnabled={false} mentions={null} entryData={tAndC} showcomments={false}
            hasSubject={false} fullheight="1000px" isadmin={true} handleTemplateId={() => { }} />}
        <FormControlLabel
            control={<Checkbox
                checked={agreement || false}
                onChange={handleAgreement}
                color='primary'
            />}
            label='I have read and agree to the Terms and Conditions'
            labelPlacement='end'
            className="col m-1"
        />
    </Drawer>
}